export function createEvent({ type, bubbles = false, cancelable = false }) {
  if (typeof Event === 'function') {
    return new Event(type, { bubbles, cancelable })
  }
  const event = document.createEvent('Event')
  event.initEvent(type, bubbles, cancelable)
  return event
}

export function cloneEvent(oldEvent) {
  return createEvent(oldEvent)
}
